var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tiptap-vuetify',{attrs:{"placeholder":"프로젝트에 대한 설명을 해주세요.","extensions":_vm.extensions},on:{"input":_vm.input},model:{value:(_vm.explanation),callback:function ($$v) {_vm.explanation=$$v},expression:"explanation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }